import { createContext, useEffect, useState, useContext } from "react";
import {
  getSheetValues,
  checkUserSheet,
  createUserSheet,
} from "../service/googlesheetService";
import Cookies from "js-cookie";
import { Score } from "../Entities/Score";
import userContext from "./userContext";



const dataContext = createContext();

let stateData = {
  connexion: { title: "Connexion à la base de données", value: "en cours" },
  questions: { title: "Récupération des questions", value: "" },
  response: { title: "Récupération des réponses du questionnaire", value: "" },
  checkData: { title: "Vérification des données", value: "" },
  responseUser: { title: "Récupération des réponses", value: "" },
};

const Provider = ({ children }) => {
  const [questions, setQuestions] = useState(new Set());
  const [answers, setAnswers] = useState([]);
  const [resultData, setResultData] = useState([]);
  const [rawData, setRawData] = useState(null);
  const [iconsData, setIconsData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(stateData);
  const { user } = useContext(userContext);

  // Get All Questions from BPM Tribe
  const getDataQuestions = async (token) => {
    const dataResponse = await getSheetValues(
      token,
      "Questions_BPM",
      "A2:J"
    );
    setLoadingDetail((prev) => ({
      ...prev,
      questions: { title: "Récupération des questions", value: "ok" },
    }));
    setQuestions(dataResponse);
  };

  //Transform user data into Score
  const transformDataIntoResult = (data) => {
    const result = new Score(data);
    return result.result;
  };

  //GetIconForExpertiseDomain
  const getIcons = async (token) => {
    const dataResponse = await getSheetValues(token, "Settings", "I3:K");
    setIconsData(dataResponse);
  };

  //Get all user answers
  const getDataUser = async (user,token) => {
    if (token) {
      //2nd parameter will change dynamically after everything's done
      const dataResponse = await getSheetValues(token, user.googleId, "A:K");
      if (dataResponse) {
        setRawData(dataResponse);
        const result = transformDataIntoResult(dataResponse);
        setResultData(result);
        setLoadingDetail((prev) => ({
          ...prev,
          responseUser: { title: "Récupération des réponses", value: "ok" },
        }));
      }
    } else {
      setRawData(null);
    }
  };

  // Get answers for the forms
  const getAnswer = async (token) => {
    const answersResponse = await getSheetValues(
      token,
      "Settings",
      "E3:G"
    );
    setLoadingDetail((prev) => ({
      ...prev,
      response: {
        title: "Récupération des réponses du questionnaire",
        value: "ok",
      },
    }));

    setAnswers(answersResponse);
  };

  // Check if the user already filled some questions
  const checkIfSheetCreated = async (user,token) => {
    if (user) {
      const check = await checkUserSheet(token, user.googleId);
      setLoadingDetail((prev) => ({
        ...prev,
        checkData: { title: "Vérification des données", value: "ok" },
      }));
      if (!check) {
        await createUserSheet(token, user.googleId);
        
      } else {
        await getDataUser(user,token);
      }
    }
    setLoadingDetail((prev) => ({
      ...prev,
      checkData: { title: "Vérification des données", value: "ok" },
    }));
  };

  useEffect(() => {
    const userCookie = Cookies.get("user");
    const token = localStorage.getItem("idToken")


    const getFullData = async (userCookie) => {
      if (token) {
        setLoadingData(true);
        await getDataQuestions(token);
        await getAnswer(token);
        await checkIfSheetCreated(userCookie,token);
        await getIcons(token);
        setLoadingData(false);
      }
    };

    if (userCookie) {
      const parsJsonUser = JSON.parse(userCookie);
      getFullData(parsJsonUser);
    }
    // eslint-disable-next-line
  }, [user]);

  return (
    <dataContext.Provider
      value={{
        icons: iconsData,
        datas: questions,
        answers,
        resultData,
        rawData,
        loadingData,
        loadingDetail,
      }}
    >
      {children}
    </dataContext.Provider>
  );
};

export { Provider };
export default dataContext;
